/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// @mui material components
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import { formatDate } from "utils";
// components
import SoftBox from "components/SoftBox";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// table
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { BusinessCodeService } from "services/businessCodeService";

const renderData = (items, setDataTable) => {
  return items.map((item, index) => ({
    id: item._id,
    code: item?.code,
    name: item?.name,
    level: item?.level,
    isRestricted:
      item?.isRestricted && item?.isRestricted === true ? "Bị hạn chế" : "Không hạn chế",
    // action: <ActionCell item={item} index.js={item._id} setDataTable={setDataTable} />,
  }));
};

const tableData = {
  columns: [
    {
      Header: "Mã ngành nghề",
      accessor: "code",
    },
    {
      Header: "Tên ngành nghề",
      accessor: "name",
      width: "15%",
    },
    {
      Header: "Cấp độ",
      accessor: "level",
    },
    {
      Header: "Hạn chế",
      accessor: "isRestricted",
    },
    // { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

function BusinessCode() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 25,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const {
        data: { items, paginate },
      } = await BusinessCodeService.getPaginate({ limit: 100, ...query });
      setPaginationData((prev) => ({ ...prev, count: paginate.count, size: paginate.size }));
      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items, setDataTable, fetchData),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error({ error });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default BusinessCode;
